<i18n>
  {
    "fr": {
      "title": "À propos de nous",
      "about-us": {
        "1": "Depuis sa création en 1991, AMPLITUDES se développe au rythme régulier de sa notoriété grandissante s’assurant ainsi de solides bases commerciales, techniques et financières.",
        "2": "Culture de la différence, stratégie de l’excellence, recherche permanente de l’innovation, démarches en matière de développement durable, AMPLITUDES se veut entreprise citoyenne.",
        "3": "Une équipe stable de professionnels fédérés autour d’un dirigeant impliqué et de valeurs fortes caractérise aujourd’hui AMPLITUDES, une entreprise pérenne reconnue pour la qualité et la pertinence de son travail dans ses quatre métiers : le voyage de groupe, le voyage de loisir, le voyage d’affaire et le voyage adapté."
      },
      "legal-information": {
        "title": "Informations légales",
        "text": {
          "1": "AVIATEUR, 37 ter rue de Metz 31000 TOULOUSE (France)",
          "2": "Téléphone: 0033 5 67 31 70 00 - Fax: 0033 5 67 31 70 18",
          "3": "Vigma SAS au capital de 550 000 Euros",
          "4": "Siret 380.775.122.00035",
          "5": "RCS B 380 775 122",
          "6": "Code APE 7911 Z",
          "7": "Responsabilité civile professionnelle AXA Assurances, contrat n° 539538504",
          "8": "Numéro immatriculation ROVS IM 031100041",
          "9": "N° TVA INTRACOMMUNAUTAIRE FR 28 380775122",
          "10": "Garant ATRADIUS - 44, Avenue Georges Pompidou - 92596 Levallois Perret Cedex"
        }
      },
      "credits": {
        "title": "Credits"
      }
    },
    "en": {
      "title": "About us",
      "about-us": {
        "1": "Since its creation in 1991, AMPLITUDES has been developing at the steady pace of its growing notoriety, thus ensuring a solid commercial, technical and financial foundation",
        "2": "With a culture of difference, a strategy of excellence, a permanent search for innovation, and a sustainable development approach, AMPLITUDES aims to be a good corporate citizen",
        "3": "A stable team of professionals federated around a committed CEO and strong values characterizes today AMPLITUDES, a perennial company recognized for the quality and relevance of tis work in its four businesses: group travel, leisure travel, business travel and adapted travel."
      },
      "legal-information": {
        "title": "Legal information",
        "text": {
          "1": "AVIATEUR, 37 ter rue de Metz 31000 TOULOUSE (France)",
          "2": "Téléphone: 0033 5 67 31 70 00 - Fax: 0033 5 67 31 70 18",
          "3": "Vigma SAS au capital de 550 000 Euros",
          "4": "Siret 380.775.122.00035",
          "5": "RCS B 380 775 122",
          "6": "Code APE 7911 Z",
          "7": "Responsabilité civile professionnelle AXA Assurances, contrat n° 539538504",
          "8": "Numéro immatriculation ROVS IM 031100041",
          "9": "N° TVA INTRACOMMUNAUTAIRE FR 28 380775122",
          "10": "Garant ATRADIUS - 44, Avenue Georges Pompidou - 92596 Levallois Perret Cedex"
        }
      },
      "credits": {
        "title": "Credits"
      }
    }
  }
</i18n>
<template>
  <div>
    <v-card
      class="mx-auto my-8"
      max-width="70%"
    >
      <v-card-text>
        <h1>{{ $t('title') }}</h1>
        <div class="mt-4">
          <div>
            <p>{{ $t('about-us.1') }}</p>
            <p>{{ $t('about-us.2') }}</p>
            <p>{{ $t('about-us.3') }}</p>
          </div>
          <v-divider />
          <div>
            <h2 class="my-4">
              {{ $t('legal-information.title') }}
            </h2>
            <p>{{ $t('legal-information.text.1') }}</p>
            <p>{{ $t('legal-information.text.2') }}</p>
            <p>{{ $t('legal-information.text.3') }}</p>
            <p>{{ $t('legal-information.text.4') }}</p>
            <p>{{ $t('legal-information.text.5') }}</p>
            <p>{{ $t('legal-information.text.6') }}</p>
            <p>{{ $t('legal-information.text.7') }}</p>
            <p>{{ $t('legal-information.text.8') }}</p>
            <p>{{ $t('legal-information.text.9') }}</p>
            <p>{{ $t('legal-information.text.10') }}</p>
          </div>
          <v-divider />
          <h2 class="my-4">
            {{ $t('credits.title') }}
          </h2>
          <div>
            Icons made by <a
              href="https://www.flaticon.com/authors/freepik"
              title="Freepik"
            >Freepik</a> from <a
              href="https://www.flaticon.com/"
              title="Flaticon"
            >www.flaticon.com</a>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Info',
  computed: {
    dialog: {
      get () {
        return this.$store.state.general.infoDialog
      },
      set (newVal) {
        this.$store.commit('general/changeInfoDialog', newVal)
      }
    }
  }
}
</script>

<style scoped>
  .headline {
    color: white;
  }
</style>
